import routes from "./routes";
import {connect} from 'redux-vue';
import VueRouter from 'vue-router';
import AxiosConfig from "../AxiosConfig";
import * as appActions from '../actions/app';
import {scrollBehavior, setAppLang} from '../helpers/tools';
import * as modulesActions from "../actions/modules";
import * as notificationsActions from "../actions/notifications";
import * as userActions from "../actions/user";

/**
 *
 * @type {VueRouter}
 */
const router = new VueRouter({
  routes,
  scrollBehavior,
  mode: 'history',
  base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
  if (to.params.locale === from.params.locale) {
    next();
    return;
  }
  const { locale } = to.params;
  setAppLang(locale);
  next();
});


export {router};
/**
 *
 */
const RouterComponent = {
  /**
   *
   */
  props: ['user', 'clearErrors', 'fetchNotifications', 'fetchUserData', 'fetchModules', 'checkAuth', 'setLocale'],

  /**
   *
   */
  async created () {
    //await this.checkAuth()
    if (this.user.token) {
      AxiosConfig.setAuthToken(this.user.token);
      //this.fetchNotifications();
    }
    this.authGuard();
    this.clearErrors();
    this.fetchUserData();
    this.fetchModules();
  },

  computed: {
    isAuthorized() {
      return Boolean(this.user.token && this.user.model);
    }
  },

  /**
   *
   */
  watch: {
    '$route': 'authGuard',
    '$i18n.locale'(nextVal, val) {
      if(nextVal !== val) {
        if (this.user.token) {
          this.setLocale(nextVal);
        }
      }
    },
    user(nextVal, val) {
      if (val.token !== nextVal.token) {
        this.fetchModules();
        if (nextVal.token) {
          //this.fetchNotifications();
        } else {
          this.$router.push('/');
        }
      }
    }
  },

  /**
   *
   */
  methods: {
    authGuard () {
      if (this.$route.meta.requiresAuth && !this.isAuthorized) {
        this.$router.push({
          name: 'LoginModal',
          query: { redirect: this.$route.name }
        });
      }
      if (this.$route.meta.hideFromAuth && this.isAuthorized) {
        this.$router.replace({ name: 'CoursesPage'});
      }
      router.beforeEach((to, from, next) => {
        if (to.meta.requiresAuth && !this.isAuthorized) next({
          name: 'LoginModal',
          query: { redirect: to.name }
        });
        else if (to.meta.hideFromAuth && this.isAuthorized) next({
          name: 'CoursesPage'
        });
        else next();
      });
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    return (
      <div>
        <router-view/>
        <router-view name="modal"/>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapActionToProps(dispatch) {
  return {
    clearErrors: () => dispatch(appActions.clearErrors()),
    fetchUserData: () => dispatch(appActions.fetchUserData()),
    checkAuth: () => dispatch(userActions.checkAuth()),
    fetchModules: () => dispatch(modulesActions.fetchModules()),
    //fetchNotifications: () => dispatch(notificationsActions.fetchNotifications()),
    setLocale: (locale) => dispatch(userActions.setLocale(locale))
  };
}

export default connect(mapStateToProps, mapActionToProps)(RouterComponent);
